import { ElxActionButton, IElxButtonBaseProps } from '@elixir/components';
import React from 'react';

export const EHActionButton = (props: IElxButtonBaseProps): JSX.Element => {
  return <ElxActionButton {...props} />;
};
